export enum EOrganizationType {
    PERFORMANCE,
    CLINIC
}
